module.exports = __webpack_public_path__ + "img/certified@2x.aff2306.webp";